import { createSlice } from "@reduxjs/toolkit";

// 👇 Read saved value from localStorage (true = full privacy / offline)
const savedPrivacy = localStorage.getItem("isFullPrivacy");

const initialState = {
  isFullPrivacy: savedPrivacy ? JSON.parse(savedPrivacy) : true,
};

const privacySlice = createSlice({
  name: "privacy",
  initialState,
  reducers: {
    // ✅ Toggle manually (used in Privacy Modal)
    togglePrivacyMode: (state) => {
      state.isFullPrivacy = !state.isFullPrivacy;
      // Save to localStorage whenever toggled
      localStorage.setItem(
        "isFullPrivacy",
        JSON.stringify(state.isFullPrivacy)
      );
    },

    // ✅ Set privacy from backend (used in fetchPreferences)
    setPrivacyMode: (state, action) => {
      state.isFullPrivacy = action.payload;
      // persist backend value to localStorage
      localStorage.setItem("isFullPrivacy", JSON.stringify(action.payload));
    },
  },
});

export const { togglePrivacyMode, setPrivacyMode } = privacySlice.actions;
export default privacySlice.reducer;
